import { InteractiveElement } from 'types/interactiveWidget.types';
import { AccessibleElement, Widget } from 'types/widget.types';

import { ArrowStyleTypeKeys, LineWidgetDashArrayTypeKeys } from '../common/CommonLine.types';

export const enum LineIconType {
  HalfCurve = 'half-curve',
  QuarterCurve = 'quarter-curve',
}

export interface LineIconWidgetData extends Widget, AccessibleElement, InteractiveElement {
  type: LineIconType;

  strokeWidth: number;
  strokeColor: string;
  strokeDashType: LineWidgetDashArrayTypeKeys;
  startArrowStyle: ArrowStyleTypeKeys;
  endArrowStyle: ArrowStyleTypeKeys;

  // generic icon data
  mirror: {
    isHorizontal?: boolean;
  };
}

interface LineIconLayoutProps {
  // unique id per component instance
  id: string;
  widthPx: number;
  heightPx: number;
  strokeColor: string;
  strokeWidth: number;
  strokeDashType: LineWidgetDashArrayTypeKeys;
  startArrowStyle: ArrowStyleTypeKeys;
  endArrowStyle: ArrowStyleTypeKeys;
  type: LineIconType;
  mirror?: LineIconWidgetData['mirror'];
  isReadOnly?: boolean;
}

export type { LineIconLayoutProps };
